import { render } from "./NavDialog.vue?vue&type=template&id=36564472&scoped=true&ts=true"
import script from "./NavDialog.vue?vue&type=script&lang=ts"
export * from "./NavDialog.vue?vue&type=script&lang=ts"

import "./NavDialog.vue?vue&type=style&index=0&id=36564472&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36564472"]])

export default __exports__